import { jsx as d, jsxs as M } from "../../_virtual/jsx-runtime.mjs";
import * as e from "react";
import { scrollContatinerWrapper as E, scrollContatiner as T, scrollBar as w } from "./ScrollContainer2.mjs";
import H from "../../utils/windowResizeListener.mjs";
import R from "../../depend/classnames/index.mjs";
const y = (r) => {
  const s = e.useRef(0), n = e.useRef(null), [f, b] = e.useState(0), [g, S] = e.useState(0), o = e.useCallback(() => {
    const t = n.current;
    if (t) {
      const { scrollTop: i, scrollHeight: v, clientHeight: l } = t, u = l / v, B = l * u, C = i * u;
      s.current = l - B, b(B), S(C);
    }
  }, []);
  e.useEffect(() => {
    o();
  }, [o]);
  const p = e.useMemo(
    () => ({
      "--scroll-bar-top": `${g}px`,
      "--scroll-bar-height": `${f}px`,
      height: r.height,
      maxHeight: r.maxHeight
    }),
    [r.height, r.maxHeight, f, g]
  ), a = e.useRef(!1), c = e.useRef(0), x = e.useCallback((t) => {
    a.current = !0, c.current = t.clientY;
  }, []), m = e.useCallback(() => {
    a.current = !1, c.current = 0;
  }, []), h = e.useCallback((t) => {
    if (a.current && n.current) {
      if (c.current) {
        const i = t.clientY - c.current;
        S(
          (u) => (
            // 滚动条最小值为0，最大值为可滚动距离
            Math.min(Math.max(u + i, 0), s.current)
          )
        );
        const l = i / s.current * n.current.scrollHeight;
        n.current.scrollTop += l;
      }
      c.current = t.clientY;
    }
  }, []);
  return e.useEffect(() => (document.addEventListener("mouseup", m), document.addEventListener("mousemove", h), H.add(o), () => {
    document.removeEventListener("mouseup", m), document.removeEventListener("mousemove", h), H.remove(o);
  }), [h, m, o]), /* @__PURE__ */ d("div", { className: E, children: /* @__PURE__ */ M(
    "div",
    {
      className: R(T, r.containerClassName),
      ref: n,
      style: p,
      onScroll: o,
      children: [
        s.current ? /* @__PURE__ */ d(
          "div",
          {
            className: R(w, r.scrollBarClassName),
            onMouseDown: x
          }
        ) : null,
        /* @__PURE__ */ d(
          "div",
          {
            style: {
              userSelect: a.current ? "none" : "auto"
            },
            children: r.children
          }
        )
      ]
    }
  ) });
};
export {
  y as default
};
//# sourceMappingURL=ScrollContainer.mjs.map
